<template>
	<div class="form-group">
		<label v-if="field.question">
			{{ field.question }}
			<span class="btn btn-primary btn-xs text-sm" @click="toggleInfo" v-if="hasInfo">Show Details</span>
		</label>
        <small 
        v-if="requiredIncomplete"
        class="ml-1" style="color:#FF0000"    
    >{{  $t('required')}}</small>
		<div v-if="field.description" v-html="field.description"></div>
		<div v-if="(this.viewinfo && field.info)" v-html="field.info" class="mr-2 text-sm"></div>
		<template v-if="readonly">
			<div v-html="field.value"></div>
		</template>
		<template v-else>
			<vue-editor 
                v-model="field.value" 
                :disabled="readonly"
                :class="{            'requiredincomplete': requiredIncomplete,
            }"
            ></vue-editor>
		</template>
		<WordCharCounter
			v-if="field.enableCount"
			:text="field.value || ''"
			:limit="(field.countLimit === null || field.countLimit === '') ? 100 : field.countLimit"
			:mode="(field.countMode === null || field.countMode === '') ? 'words' : field.countMode"
            @limit-exceeded="limitExceeded"
		/>

	</div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import WordCharCounter from "@/components/WordCharCounter.vue";

export default {
	components: {
		VueEditor,
		WordCharCounter
	},
	props: ['field', 'readonly','viewAs'],
	data() {
		return {
			'viewinfo': false
		}
	},
	methods: {
        toggleInfo() {
        	this.viewinfo = !this.viewinfo;
        },
        limitExceeded(payload){
            this.$emit("limit-exceeded", payload);
        }
    },
    computed: {
        requiredIncomplete() {
            return (this.field.permission.includes(this.viewAs) || this.field.permission.length === 0) 
            && this.field.required && !this.field.value ;
        },
        hasInfo() {
        	if(this.field.info){
        		return true;
        	}
        	return false;
        }
    },
};
</script>
